
import React from 'react';
import { cn } from "@/lib/utils";

interface TableHeaderProps extends React.ThHTMLAttributes<HTMLTableCellElement> {
  children: React.ReactNode;
}

const TableHeader = ({ children, className, ...props }: TableHeaderProps) => {
  return (
    <th
      className={cn(
        "h-12 px-4 text-left",
        "text-sm font-medium text-muted-foreground",
        "sticky top-0 bg-background/5 backdrop-blur-sm",
        "whitespace-nowrap",
        className
      )}
      {...props}
    >
      {children}
    </th>
  );
};

export default TableHeader;
